import { Globals } from "../global/Globals";

const secretKey=Globals.SECRET_KEY;
const CryptoUtils = {
    encrypt: (data) => {
      try {
        const jsonString = JSON.stringify(data);
        return btoa(unescape(encodeURIComponent(jsonString)));
      } catch (error) {
        console.error('Encryption failed:', error);
        return null;
      }
    },
  
    decrypt: (encryptedData) => {
      try {
        const decodedString = decodeURIComponent(escape(atob(encryptedData)));
        return JSON.parse(decodedString);
      } catch (error) {
        console.error('Decryption failed:', error);
        return null;
      }
    },
  
    saveToLocalStorage: (key, data) => {
      const encryptedData = CryptoUtils.encrypt(data);
      if (encryptedData) {
        localStorage.setItem(key, encryptedData);
      }
    },
  
    getFromLocalStorage: (key) => {
      const encryptedData = localStorage.getItem(key);
      if (encryptedData) {
        return CryptoUtils.decrypt(encryptedData);
      }
      return null;
    },
  
    saveToCookie: (key, data, expiryDays = 60) => {
      const encryptedData = CryptoUtils.encrypt(data);
      if (encryptedData) {
        const date = new Date();
        date.setTime(date.getTime() + expiryDays * 60 * 60 * 1000);
        document.cookie = `${key}=${encryptedData};expires=${date.toUTCString()};path=/`;
        CryptoUtils.saveToLocalStorage('isCookieAvailable',true);
      }
    },
  
    getFromCookie: (key) => {
      const cookies = document.cookie.split('; ');
      for (let cookie of cookies) {
        const [cookieKey, cookieValue] = cookie.split('=');
        if (cookieKey === key) {
          return CryptoUtils.decrypt(cookieValue);
        }
      }
      return null;
    },

    setSecretKey:()=>{
      const encryptedKey=CryptoUtils.encrypt(secretKey);
      return encryptedKey;
    }
  };
  
  export default CryptoUtils;  